import { render, staticRenderFns } from "./ProductsSoldTogether.vue?vue&type=template&id=618b1b75"
import script from "./ProductsSoldTogether.vue?vue&type=script&lang=js"
export * from "./ProductsSoldTogether.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports